import { EnrollmentResponseDto } from './EnrollmentResponseDto';
import { WorkflowCompletionDto } from './WorkflowCompletionDto';

export type { EnrollmentResponseDto } from './EnrollmentResponseDto';
export type { WorkflowCompletionDto } from './WorkflowCompletionDto';

export type WorkflowStartResponse = EnrollmentResponseDto | WorkflowCompletionDto;

export function isWaitingForInput(r: WorkflowStartResponse): r is EnrollmentResponseDto {
  return 'enrollmentId' in r;
}

export function isWorkflowCompleted(r: WorkflowStartResponse): r is WorkflowCompletionDto {
  return !('enrollmentId' in r);
}
